const Config = {
  ADMIN_PANEL: 'https://playout006.noisypeak.com',
  //ADMIN_PANEL: 'http://localhost:8081',
}

export default Config
